import 'core-js/modules/es.symbol';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'intersection-observer';
import 'custom-event-polyfill';
import 'whatwg-fetch';

import initData from 'init-data';
import {
    handleModuleError,
    isSpaModule,
    loadModule,
    loadSpaModule,
    runModule
} from 'utils/modules';
import { bootLanguages } from 'tradera-lang';
import gtm from 'static/script/app/ui/google-tagmanager-service';

bootLanguages();
gtm.loadGtmScript();

if (initData) {
    const module = initData.module.split('/')[4];
    let moduleLoader;
    if (isSpaModule(module, initData)) {
        moduleLoader = loadSpaModule(initData);
    } else {
        moduleLoader = import('./init-module')
            .then(initModule => initModule.default(initData))
            .then(() => loadModule(module, initData))
            .then(loadedModule => runModule(loadedModule, initData));
    }
    moduleLoader
        .then(() => {
            window.document.body.setAttribute('data-module-loaded', 'true');
            return;
        })
        .catch(handleModuleError);
}
